import React, { useMemo } from "react";
import styles from "./CommonPagination.module.css";

const CommonPagination = ({
  page,
  totalPages,
  totalRecords,
  limit,
  onPageChange,
  onLimitChange,
  limitStart = 100,
  limitEnd = 5000,
  limitStep = 500,
}) => {

  // Dynamic limit options + ALL
  const limitOptions = useMemo(() => {
    const arr = ["ALL"]; // ✅ Always first
    for (let i = limitStart; i <= limitEnd; i += limitStep) {
      arr.push(i);
    }
    return arr;
  }, [limitStart, limitEnd, limitStep]);

  return (
    <div className={styles.wrapper}>
      
      {/* LEFT */}
      <div className={styles.left}>
        <span>Page <b>{page}</b> / {totalPages || 1}</span>
        <span>Total: <b>{totalRecords || 0}</b></span>
      </div>

      {/* RIGHT */}
      <div className={styles.right}>

        {/* LIMIT (SMALL) */}
        <select
          value={limit}
          onChange={(e) =>
            onLimitChange(e.target.value === "ALL" ? "all" : Number(e.target.value))
          }
          className={styles.selectSmall}
        >
          {limitOptions.map((l) => (
            <option key={l} value={l}>
              {l === "ALL" ? "All" : l}
            </option>
          ))}
        </select>

        {/* PREV */}
        <button
          disabled={page === 1}
          onClick={() => onPageChange(page - 1)}
          className={styles.btnSmall}
        >
          Prev
        </button>

        {/* NEXT */}
        <button
          disabled={page === totalPages}
          onClick={() => onPageChange(page + 1)}
          className={styles.btnSmall}
        >
          Next
        </button>

      </div>
    </div>
  );
};

export default CommonPagination;